import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mojo-original-layout',
    templateUrl: './original-layout.component.html',
    styleUrls: ['./original-layout.component.scss'],
    standalone: false
})
export class OriginalLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
